import React, { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Modal, ModalTitle, QuestionModalFooter } from "core/uicore";
import { Button } from "core/controls";
import { tickLogo, closeIcon } from "assets";
import {
  INFORCE,
  NEW_BUSINESS,
  SHARED_OWNERSHIP,
  EAPPLICATION,
  ADMIN,
  BI,
} from "../utils/constants";
import { usePCTranslation } from "core/hooks";

const SwitchProductModal = ({
  controlClick,
  controlGetFocus,
  onSelectProduct,
  onCancel,
  controlLostFocus,
  setElement,
  route,
  isMobile,
}) => {
  const { user, controlItems } = useSelector(
    (state) => ({
      user: state.auth.user,
      controlItems: state.setupItems.controlItems,
    }),
    shallowEqual
  );
  const { t } = usePCTranslation();
  const [selectedItem, setSelectedItem] = useState(route);
  // const [disabled, setDisabled] = useState(true);

  // useEffect(() => {
  //   setSelectedItem(route);
  // }, [])

  // This is for clicking the product, item is index of the product
  const handleSelectItem = (e, item) => {
    controlClick(e, `${item}Switch`, item);
    setSelectedItem(item);
    // if (item === SHARED_OWNERSHIP || item === EAPPLICATION) {
    //   setSelectedItem(item);
    // } else if ((user.isInforce && item === INFORCE) || (user.isNewBusiness && item === NEW_BUSINESS)) {
    //   setSelectedItem(item);
    // setDisabled(false);
    // }
  };

  //This is for clicking Choose button and closing modal
  const handleChoose = () => {
    onSelectProduct(selectedItem);
  };
  if (!user) {
    return null;
  }

  const switchButton = (
    switchBtnName,
    itemId,
    isPermitted,
    logoName = "logoHdrNewBusiness"
  ) => (
    <button
      id={switchBtnName}
      onClick={(e) => handleSelectItem(e, itemId)}
      className={`PAGELINK fullWidth justifyStart flexContainer alignCenter paddingMed ${
        isPermitted ? "cursorPointer" : "disabled"
      } ${logoName} borderRadiusAll ${
        selectedItem === itemId && isPermitted ? "activeLink" : ""
      }`}
      disabled={!isPermitted}
    >
      <div className="flexContainer noCols alignCenter noWrap flexGrow justifyBetween">
        <label className="PAGETITLE borderNone fontMed">
          {t(switchBtnName)}
        </label>
        <img className="tick-icon" name="tick" src={tickLogo} alt="" />
      </div>
    </button>
  );

  return (
    <Modal onClick={(e) => e.stopPropagation()} propStyle="modalDark">
      <div className="modalcontainerSm paddingLg borderRadiusAllLg">
        <Button
          text="Cancel"
          getfocusCallback={controlGetFocus}
          getclickCallback={(event, name, value) => {
            controlClick(event, name, value);
            onCancel();
          }}
          lostfocusCallback={controlLostFocus}
          name="btnXSwitchProductCancel"
          refItem={setElement}
          propStyle={{
            label: "buttonlabel",
            control: `modalClose`,
          }}
          logo={{
            srcLogo: closeIcon,
            altLogo: "",
            classLogo: "branding-image-filter",
          }}
          showIcon={true}
        />
        <div className="OPENSAVEMODALCONTENTS modalWrapper">
          <div className="modalHeaderSm">
            <ModalTitle title={"SwitchProducts"} t={t} fontSize="fontHdr2" />
          </div>
          <div className="modal-content">
            {user.system.isInforce &&
              switchButton(
                "inforceSwitch",
                INFORCE,
                user?.permissions?.isInforce?.isActive,
                "logoHdrInforce"
              )}
            {user.system.isNewBusiness &&
              switchButton(
                "illustrationSwitch",
                NEW_BUSINESS,
                user?.permissions?.isNewBusiness?.isActive,
                "logoHdrNewBusiness"
              )}
            {route === NEW_BUSINESS &&
              !isMobile &&
              user.system.isConcepts &&
              switchButton(
                "sharedOwnershipSwitch",
                SHARED_OWNERSHIP,
                user?.permissions?.isNewBusiness?.isActive
              )}
            {(route === NEW_BUSINESS || route === EAPPLICATION) &&
              user?.permissions?.isEapplicationAdministrator?.isActive &&
              user.system.isEapplication &&
              switchButton(
                "eappSettingSwitch",
                EAPPLICATION,
                user?.permissions?.isEapplication?.isActive,
                "logoHdrEApplication"
              )}

            {user.system.isBusinessIntelligence &&
              user?.permissions?.isBusinessIntelligence?.isDisplayed &&
              switchButton(
                "biSwitch",
                BI,
                user?.permissions?.isBusinessIntelligence?.isActive
              )}
            {(user?.permissions?.isAdmin?.isActive ||
              (user.system.isBusinessIntelligence &&
                user?.permissions?.isBusinessIntelligence?.isActive) ||
              ((user?.permissions?.isAdminSystem?.isActive ||
                user?.permissions?.isAdminSystemAdministrator?.isActive) &&
                user.system.isAdminSystem)) && (
              <div
                id={`${ADMIN}Switch`}
                onClick={(e) => handleSelectItem(e, ADMIN)}
                className={`PAGELINK fullWidth justifyStart flexContainer alignCenter paddingMed cursorPointer logoHdrNewBusiness borderRadiusAll ${
                  selectedItem === ADMIN &&
                  (user?.permissions?.isAdmin?.isActive ||
                    (user.system.isBusinessIntelligence &&
                      user?.permissions?.isBusinessIntelligence?.isActive))
                    ? "activeLink"
                    : ""
                }`}
                disabled={!user?.permissions?.isAdmin?.isActive}
              >
                <div className="flexContainer noCols alignCenter noWrap flexGrow justifyBetween">
                  <label className="PAGETITLE borderNone fontMed">
                    {t("adminSwitch")}
                  </label>
                  <img
                    className="tick-icon"
                    name="tick"
                    src={tickLogo}
                    alt=""
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <QuestionModalFooter
          controlGetFocus={controlGetFocus}
          controlLostFocus={controlLostFocus}
          controlClick={controlClick}
          setElement={setElement}
          onSelectOK={handleChoose}
          onSelectCancel={onCancel}
          btnCancel={"btnSwitchProductCancel"}
          btnOK={"btnSwitchProductChoose"}
        />
      </div>
    </Modal>
  );
};

export default SwitchProductModal;
